import { render, staticRenderFns } from "./ApartmentModal.vue?vue&type=template&id=64f9108d&"
import script from "./ApartmentModal.vue?vue&type=script&lang=ts&"
export * from "./ApartmentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f9108d')) {
      api.createRecord('64f9108d', component.options)
    } else {
      api.reload('64f9108d', component.options)
    }
    module.hot.accept("./ApartmentModal.vue?vue&type=template&id=64f9108d&", function () {
      api.rerender('64f9108d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apartment/components/ApartmentModal.vue"
export default component.exports